import '../../styles.global.css';
import '../../assets/styles/NotificationTemplate.module.css';

var styles = {"wrapper":"wru__NotificationTemplate__wrapper","header":"wru__NotificationTemplate__header","body":"wru__NotificationTemplate__body","errorBody":"wru__NotificationTemplate__errorBody","footer":"wru__NotificationTemplate__footer","spacer":"wru__NotificationTemplate__spacer","footerTitle":"wru__NotificationTemplate__footerTitle","bodyContent":"wru__NotificationTemplate__bodyContent","taggedBody":"wru__NotificationTemplate__taggedBody"};

export { styles as default };
//# sourceMappingURL=NotificationTemplate.module.scss.js.map
